import { createBrowserHistory, createMemoryHistory } from "history";
import { isExtension } from "utils/extension";

const currentHistory = createBrowserHistory();

export default currentHistory;
